module.exports = __webpack_public_path__ + "r-v3/img/ml_41_00.32bfaa84.jpg";